var map = {
	"./images/alarm.png": 91916,
	"./images/capturAGP-logo.png": 6978,
	"./images/diagonalStripes.png": 67342,
	"./images/event-health.png": 82536,
	"./images/event-notes.png": 3143,
	"./images/event-physical_activity.png": 37233,
	"./images/sitechange-cannula.png": 27853,
	"./images/sitechange-loop-tubing.png": 63789,
	"./images/sitechange-reservoir.png": 7158,
	"./images/sitechange-tubing.png": 92918,
	"./images/sitechange-twiist-cassette.png": 97016,
	"./images/tidepool-logo-408x46.png": 30618
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46940;